import { render } from "./ViewPlayersForLocation.vue?vue&type=template&id=22c7707e"
import script from "./ViewPlayersForLocation.vue?vue&type=script&lang=js"
export * from "./ViewPlayersForLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__